<div
  class="avatar-container"
  [ngStyle]="getContainerStyle()"
  [style]="cursor ? 'cursor: pointer;' : ''"
>

  @if (edit) {
    <div class="edit-overlay" [style.border-radius]="onCircle ? '50%' : ''">
      <div class="edit-text" (click)="method.emit()">
        <div class="row text-center">
          <div class="col-12 mb-5">
            <mat-icon>camera_alt</mat-icon>
          </div>
          <div class="col-12" style="font-size: 0.5em; line-height: 1;">
            <span>mudar foto do perfil</span>
          </div>
        </div>
      </div>
    </div>
  }

  @if (imageUrl) {
    <img [ngStyle]="getAvatarImageStyle()" [src]="imageUrl" [alt]="altText" />
  } @else {
    @if (altText) {
      <div class="avatar-text" [ngStyle]="getSizeTxt()">{{ initials }}</div>
    } @else {
      <mat-icon style="color:white !important;" [ngStyle]="getIconStyle()">person</mat-icon>
    }
  }
</div>
